import React from 'react';

import { faList, faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';

import { useDispatch, useSelector } from 'bundles/research/index/store/hooks';
import { switchTab } from 'bundles/research/index/store/actions/ui';

import Toggle from 'bundles/research/index/components/toggle';

export default function ViewToggle() {
  const currentTab = useSelector(state => state.ui.currentTab);
  const dispatch = useDispatch();

  return (
    <Toggle
      options={[
        { label: 'Map view', value: 'maps', icon: faMapMarkerAlt },
        { label: 'Table view', value: 'properties', icon: faList },
      ]}
      value={currentTab}
      onChange={value => dispatch(switchTab(value))}
    />
  );
}
